import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Flex, Text, Tooltip } from "@mantine/core";
import type { ReactNode } from "react";

interface ScreenerBuilderInputLabelProps {
  infoText?: string;
  label: ReactNode;
  required?: boolean;
  readOnly?: boolean;
}

export const ScreenerBuilderInputLabel = ({
  infoText,
  label,
  required = false,
  readOnly = false,
}: ScreenerBuilderInputLabelProps) => {
  return (
    <Flex justify="space-between">
      <Flex align="center">
        <Text className="font-semibold text-sm">
          {label}
          {required && !readOnly && "*"}
        </Text>
        {infoText && (
          <Tooltip
            className="py-3 text-center"
            multiline
            label={infoText}
            w={260}
          >
            <FontAwesomeIcon
              className="ml-1 text-uw-purple-3"
              icon={faInfoCircle}
            />
          </Tooltip>
        )}
      </Flex>
      {!readOnly && !required && (
        <Text className="text-sm text-uw-gray-5">Optional</Text>
      )}
    </Flex>
  );
};
